import { Box, Paper, Typography,Grid } from '@mui/material'
import React from 'react'
import { CustomField, SectionProps } from '../../../Admin/PreboardingConfiguration/CandidateDetailsConfiguration/CandidateDetailsConfiguration';
import FieldDisplay from './FieldDisplay';

interface CandidateSchoolingDetailsProps {
    retrievedFields: CustomField[];
    sectionData: SectionProps | undefined;
    fieldValues: { [key: number]: any };
    fieldErrors: { [key: number]: string };
    onFieldChange: (fieldId: number, value: any) => void;
}


const CandidateSchoolingDetails: React.FC<CandidateSchoolingDetailsProps> = ({ retrievedFields, sectionData, fieldValues, fieldErrors, onFieldChange }) => {
    return (
        <Box>
            <Typography variant="subtitle2" color="#101828" mb={1}>
                {sectionData?.sectionName}
            </Typography>
            <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
                <Grid container spacing={2}>
                    {retrievedFields
                        .filter((field) => field.sectionName === sectionData?.sectionName)
                        .reduce((acc: any[][], curr, i) => {
                            if (i % 3 === 0) acc.push([curr]);
                            else acc[acc.length - 1].push(curr);
                            return acc;
                        }, [])
                        .map((fieldPair, rowIndex) => (
                            <Grid container item spacing={2} key={rowIndex}>
                                {fieldPair.map((field, colIndex) => (
                                    <Grid item xs={12} md={4} key={colIndex}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <FieldDisplay 
                                                field={field}
                                                value={fieldValues[field.customFieldId]}
                                                error={fieldErrors[field.customFieldId]}
                                                onChange={onFieldChange}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        ))}
                </Grid>
            </Paper>
        </Box>
    )
}

export default CandidateSchoolingDetails